<div class="hotel-intro">
  <div class="hotel-name">
    <span class="name">{{ hotelStaticInfo.name }}</span>
    <ng-template #mobile>
      <div class="address-ctn-mobile">
        <ng-container *ngIf="!isHomestay; else homestay">
          <mb-stars-rating [rating]="hotelStaticInfo.stars"></mb-stars-rating>
          <span class="address">{{ hotelStaticInfo.city.name }}</span>
        </ng-container>
      </div>
    </ng-template>
    <ng-container *ngIf="!isMobile; else mobile">
      <ng-container *ngIf="hotelStaticInfo">
        <mb-stars-rating
          *ngIf="!isHomestay; else homestay"
          [rating]="hotelStaticInfo.stars"
        ></mb-stars-rating>
      </ng-container>
    </ng-container>
    <ng-template #homestay>
      <span *ngIf="isMobile"> Alquiler temporario </span>
      <ng-container *ngIf="beds > 0 && maxRoomOccupancy > 0">
        <div class="homestay-data">
          <span class="separator"></span>
          <mb-icon-text>
            <mb-icon icon="adult"></mb-icon>
            <span
              >{{ maxRoomOccupancy }}
              <ng-container *ngIf="!isMobile">Personas</ng-container>
            </span>
          </mb-icon-text>
          <mb-icon-text>
            <mb-icon icon="hotels"></mb-icon>
            <span>{{ beds }} camas</span>
          </mb-icon-text>
        </div>
      </ng-container>
    </ng-template>
  </div>
  <div *ngIf="!isMobile" class="address-ctn">
    <mb-icon-text>
      <mb-icon icon="pointer"></mb-icon>
      <span>
        <ng-container
          *ngIf="
            hotelStaticInfo.hotel_position.latitude &&
              hotelStaticInfo.hotel_position.longitude;
            else noLatitude
          "
        >
          <span class="view-in-map" (click)="trackViewMap()">{{
            hotelStaticInfo.address + ', ' + hotelStaticInfo.city.name
          }}</span>
        </ng-container>

        <ng-template #noLatitude>
          {{ hotelStaticInfo.address + ', ' + hotelStaticInfo.city.name }}
        </ng-template>
      </span>
    </mb-icon-text>
  </div>

  <mb-reviews-rating *ngIf="rating" rating="{{ rating > 4 ? rating : '' }}">
    <mb-reviews-evaluation i18n="@@rating_scale_label">{rating, select,
      5 {REGULAR}
      6 {ACEPTABLE}
      7 {BUENO}
      8 {MUY BUENO}
      9 {EXCELENTE}
      10 {FANTÁSTICO}
      other {SIN PUNTUACIÓN}
    }</mb-reviews-evaluation>
  </mb-reviews-rating>
</div>
